import {yupResolver} from '@hookform/resolvers/yup'
import {Dispatch, FC, SetStateAction, useEffect, useState} from 'react'
import {Modal} from 'react-bootstrap'
import {useForm} from 'react-hook-form'
import {KTSVG} from '../../../../../../../../_metronic/helpers'
import {InputNumber} from '../../../../../../components/UI/Input'
import {Select} from '../../../../../../components/UI/Select'
import {SelectOption} from '../../../../../../models/utility.model'
import {getSnackBar, getSnackBarToast} from '../../../../../../util/snackBar'
import {newRoomModalSchema} from '../../../../../../util/validationHoteleria'
import {useCentralServices} from '../../../../hooks/useCentralServices'
import {RoomModel} from '../../../room/models'
import {editRoomService} from '../../../room/services/editRoom.service'
import {getRoomByIdService} from '../../../room/services/getRoomById.service'
import {MasterModel} from '../../models'
import {getModuleByIdService} from '../../services'

interface Props {
  show: boolean
  setShow: Dispatch<SetStateAction<boolean>>
  roomToEdit: RoomModel
  getRooms: () => void
}

const ModalUpdateRoom: FC<Props> = ({show, setShow, roomToEdit, getRooms}) => {
  const handleClose = () => {
    setShow(false)
  }

  const {
    register,
    setValue,
    handleSubmit,
    // watch,
    control,
    formState: {errors},
    setError,
  } = useForm<RoomModel>({
    resolver: yupResolver(newRoomModalSchema),
  })

  const [roomType, setRoomType] = useState<MasterModel[] | any>([])
  const [statusRoom, setStatusRoom] = useState<MasterModel[] | any>([])
  const [subStatusRoom, setSubStatusRoom] = useState<MasterModel[] | any>([])
  const [preasignationType, setPreasignationType] = useState<MasterModel[] | any>([])
  const [genre, setGenre] = useState<MasterModel[] | any>([])
  const [level, setLevel] = useState<MasterModel[] | any>([])
  const [bathroomType, setBathroomType] = useState<MasterModel[] | any>([])
  const [receptionistComp, setReceptionistComp] = useState<SelectOption[]>([
    {value: '', label: 'CUALQUIERA'},
  ])
  const [turns, setTurns] = useState<SelectOption[]>([{value: '', label: 'CUALQUIERA'}])

  const {getMasterTable, getReceptionist} = useCentralServices()

  const getPreasignationTypesFn = async () => {
    const data = await getMasterTable('TipoPreasignacion', true)
    setPreasignationType(data)
  }

  const getGenresFn = async () => {
    const data = await getMasterTable('Sexo', true)
    setGenre(data)
  }

  const getLevelsFn = async (level: number) => {
    const data = await getMasterTable('Nivel', true)
    const orderedData = data.sort((a, b) => parseInt(a.codigo) - parseInt(b.codigo))
    const filterData = orderedData.slice(0, level)
    setLevel(filterData)
  }

  const getBathroomsTypeFn = async () => {
    const data = await getMasterTable('TipoBanio', true)
    setBathroomType(data)
  }

  const getRoomsTypeFn = async () => {
    const data = await getMasterTable('TipoHabitacion', true)
    setRoomType(data)
  }

  const getStatusRoomFn = async () => {
    const data = await getMasterTable('EstadoHabitacion', true)
    setStatusRoom(data)
  }

  const getSubStatusRoomFn = async (codigoPadre: string) => {
    const data = await getMasterTable('SubEstadoHabitacion', true, {codigoPadre})
    setSubStatusRoom(data)
  }

  const handleStatusChange = (val: any) => {
    let value = val ? val.value : ''
    setValue('EstadoHabitacionId', value)
    setValue('SubEstadoHabitacionId', '')
    setError('EstadoHabitacionId', {})
    const filtered = statusRoom.filter((item: any) => item.value === value)[0]?.codigo || ''
    getSubStatusRoomFn(filtered)
  }

  const getTurnsFn = async () => {
    const data = await getMasterTable('Turno', true)
    const allData = [{value: '', label: 'CUALQUIERA'}, ...data]
    setTurns(allData)
  }

  const getReceptionistFn = async (clienteId: string, companyId: string) => {
    const data = await getReceptionist(
      {clienteId: clienteId, companiaId: companyId, isCombo: true},
      1,
      true,
    )
    const allData = [{value: '', label: 'CUALQUIERA'}, ...data]
    setReceptionistComp(allData)
  }

  const getLevelsByModule = async (moduleId: string) => {
    try {
      const {
        data: {data},
      } = await getModuleByIdService(moduleId)
      const {NroPisos} = data
      getLevelsFn(NroPisos || 0)
    } catch (error) {}
  }

  const getRoomData = async () => {
    const {
      data: {data},
    } = await getRoomByIdService(roomToEdit.Id)
    const {
      TipoHabitacionId,
      Codigo,
      EstadoHabitacionId,
      SubEstadoHabitacionId,
      TipoPreAsignacionId,
      SexoId,
      TipoBanioId,
      NivelId,
      NroCamas,
      PrioridadAsignacion,
      ModuloId,
      SiteId,
      CampamentoId,
      TipoModuloId,
      ClienteId,
      CompaniaId,
      LotizacionEmpresaId,
      TurnoId,
    } = data
    setValue('Id', roomToEdit.Id)
    setValue('ModuloId', ModuloId)
    setValue('SiteId', SiteId)
    setValue('CampamentoId', CampamentoId)
    setValue('TipoModuloId', TipoModuloId)
    setValue('TipoHabitacionId', TipoHabitacionId)
    setValue('Codigo', Codigo)
    setValue('EstadoHabitacionId', EstadoHabitacionId)
    setValue('SubEstadoHabitacionId', SubEstadoHabitacionId)
    setValue('TipoPreAsignacionId', TipoPreAsignacionId)
    setValue('SexoId', SexoId)
    setValue('TipoBanioId', TipoBanioId)
    setValue('NivelId', NivelId)
    setValue('NroCamas', NroCamas)
    setValue('PrioridadAsignacion', PrioridadAsignacion)
    setValue('LotizacionEmpresaId', LotizacionEmpresaId || '')
    setValue('TurnoId', TurnoId || '')
    getReceptionistFn(ClienteId as any, CompaniaId as any)
    const filtered =
      statusRoom.filter((item: any) => item.value === EstadoHabitacionId)[0]?.codigo || ''
    getSubStatusRoomFn(filtered)
    getLevelsByModule(ModuloId as any)
  }

  useEffect(() => {
    getRoomData()
  }, [])

  const onSubmit = async (data: RoomModel) => {
    try {
      const {data: res} = await editRoomService(data)
      if (!res.error) {
        getSnackBarToast('Se actualizó con éxito', 'successs')
        handleClose()
        getRooms()
      } else {
        getSnackBarToast(res.message, 'error')
      }
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    getPreasignationTypesFn()
    getGenresFn()
    getBathroomsTypeFn()
    getRoomsTypeFn()
    getStatusRoomFn()
    getTurnsFn()
  }, [])

  return (
    <Modal
      className='modal fade'
      show={show}
      dialogClassName='modal-xl'
      aria-hidden='true'
      onHide={handleClose}
    >
      <div className='modal-content'>
        <div className='modal-header'>
          <h5 className='modal-title'>Editar Habitación</h5>
          <div className='btn btn-icon btn-sm btn-active-light-primary ms-2' onClick={handleClose}>
            <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-2x' />
          </div>
        </div>
        <div className='modal-body'>
          <form>
            <div className='p-6'>
              <div className='row'>
                <div className='col-sm-12 col-lg-6'>
                  <label className='required'>Tipo de Habitación:</label>
                  <Select
                    control={control}
                    name='TipoHabitacionId'
                    data={roomType}
                    errors={errors}
                  />
                </div>
                <div className='col-sm-12 col-lg-6'>
                  <label className='required'>Sexo:</label>
                  <Select control={control} name='SexoId' data={genre} errors={errors} />
                </div>
                <div className='col-sm-12 col-lg-6'>
                  <label className='required'>Nomenclatura de Habitación</label>
                  <div className='sdx_form_input'>
                    <input
                      type='text'
                      className='form-control sdx-centra-input-form'
                      {...register('Codigo')}
                    />
                    <p>{errors.Codigo?.message}</p>
                  </div>
                </div>
                <div className='col-sm-12 col-lg-6'>
                  <label className='required'>Tipo de Baño</label>
                  <Select
                    control={control}
                    name='TipoBanioId'
                    data={bathroomType}
                    errors={errors}
                  />
                </div>
                <div className='col-sm-12 col-lg-6'>
                  <label className='required'>Estado</label>
                  <Select
                    control={control}
                    name='EstadoHabitacionId'
                    data={statusRoom}
                    errors={errors}
                    onChangeValue={handleStatusChange}
                  />
                </div>
                <div className='col-sm-12 col-lg-6'>
                  <label className='required'>Pisos</label>
                  <Select control={control} name='NivelId' data={level} errors={errors} />
                </div>
                <div className='col-sm-12 col-lg-6'>
                  <label className='required'>Sub Estado</label>
                  <Select
                    control={control}
                    name='SubEstadoHabitacionId'
                    data={subStatusRoom}
                    errors={errors}
                  />
                </div>
                <div className='col-sm-12 col-lg-6'>
                  <label className='required'>Nro de Camas</label>
                  <InputNumber
                    name='NroCamas'
                    textPlaceholder='Escribe el Nro de camas'
                    register={register}
                    errors={errors}
                  />
                </div>
                <div className='col-sm-12 col-lg-6'>
                  <label className='required'>Preasignación</label>
                  <Select
                    control={control}
                    name='TipoPreAsignacionId'
                    data={preasignationType}
                    errors={errors}
                  />
                </div>
                <div className='col-sm-12 col-lg-6'>
                  <label className='required'>Nro de Secuencia de Asignacion</label>
                  <InputNumber
                    name='PrioridadAsignacion'
                    textPlaceholder='Escribe el Nro de secuencia de Asignación'
                    register={register}
                    errors={errors}
                  />
                </div>
                <div className='mb-2 col-sm-12 col-lg-6'>
                  <label className='required'>Empresa Lotización:</label>
                  <Select
                    control={control}
                    name='LotizacionEmpresaId'
                    data={receptionistComp}
                    errors={errors}
                  />
                </div>
                <div className='mb-2 col-sm-12 col-lg-6'>
                  <label className='required'>Turno:</label>
                  <Select control={control} name='TurnoId' data={turns} errors={errors} />
                </div>
              </div>
            </div>
            <div className='d-flex justify-content-center mb-3'>
              <button type='button' className='btn btn-light-primary me-5' onClick={handleClose}>
                Cancelar
              </button>
              <button type='button' className='btn btn-primary' onClick={handleSubmit(onSubmit)}>
                Guardar
              </button>
            </div>
          </form>
          {/* <pre>{JSON.stringify(watch(), null, 2)}</pre> */}
        </div>
      </div>
    </Modal>
  )
}

export {ModalUpdateRoom}
